module.exports = __webpack_public_path__ + "static/media/amusement(18).ba24748c.PNG";